import React, { useCallback } from 'react';
import { prop, pick } from 'ramda';
import { useDispatch } from 'react-redux';
import { BackboneReplacer } from '@theme/js/backbone/components/BackboneReplacer';
import { Link } from '@theme/js/components/common/Link';
import { closeSidebar, openSidebar } from '@core/js/components/main/MyAccountSidebar/store/actions';
import { AccessibilityElement } from '@core/js/components/common/AccessibilityElement';
import { useAppSelector, useUserSelector, useDeviceSelector, useMyAccountSidebarSelector } from '@core/js/store/hooks';
import { useComponentTranslations } from '@core/js/hooks/component/useComponentTranslations';

import style from './MyAccount.scss';

export const MyAccount: React.FC = () => {
    const dispatch = useDispatch();
    const translate = useComponentTranslations();
    const isMobile = useDeviceSelector(prop('isMobile')); /* Lugano changes */
    const userDetails = useUserSelector(prop('userDetails'));
    const { isShowSidebar, accountPage } = useAppSelector(pick(['isShowSidebar', 'accountPage']));

    /* Lugano changes */
    const isOpened = useMyAccountSidebarSelector(prop('isOpened'));
    const showSidebar = useCallback(() => {
        isOpened ? dispatch(closeSidebar()) : dispatch(openSidebar());
    }, [dispatch, isOpened]);

    const content = (
        <>
            <span className={`${style.usernameLinkIcon} icon-ico-s4w-user`} />
            {!isMobile && (
                <span className={style.usernameLinkName}>{userDetails?.loginName}</span>
            )}
            {isMobile && (
                <BackboneReplacer
                        isHideBackboneClass={true}
                        viewName="unreadmessagescount"
                        dynamicName="UNREAD_MESSAGES_COUNT"
                />
            )}
        </>
    );

    if (isShowSidebar) {
        return (
            <div className={style.usernameInfoBlock}>
                <AccessibilityElement
                        onClick={showSidebar}
                        className={style.account}
                        aria-label={translate('header.account.aria-label')}
                >
                    {content}
                </AccessibilityElement>
            </div>
        );
    }

    if (accountPage) {
        return (
            <div className={style.usernameInfoBlock}>
                <Link
                        href={accountPage}
                        className={style.account}
                        aria-label={translate('header.account.aria-label')}
                >
                    {content}
                </Link>
            </div>
        );
    }
    /* Lugano changes */

    return null;
};
